import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { gamesData} from 'data/games-data';
import { generalUiTexts } from 'data/ui-texts';
import {getText} from 'helpers/language-helper';
import { renderMarkdown } from 'helpers/text-helper';
import {getConfirmButtonData} from 'helpers/confirm-button-helper';
import Logo from 'components/logo/logo';
import Button from 'components/button/button';
import ProgressBar from 'components/progress-bar/progress-bar';
import CrewCardFlippable from 'components/crew-card/crew-card-flippable';
import CrewExperience from 'components/crew-experience/crew-experience';
import CrewIssues from 'components/crew-issues/crew-issues';
import './crew-feedback-heli.scss';

const CrewFeedbackHeli = (props) => {
	let {
		game,
		group,
		handleGoToPage,
		handleSelectSlotCRMH, 
		confirmAndContinue, 
	} = props;

	let [selectedCard, setSelectedCard] = useState(null);
	let [selectedSlotId, setSelectedSlotId] = useState(null);

	const crewData = gamesData[game.type].crewData;

	/* Game step data */
	const gameStepData = gamesData[game.type].gameSteps.find((step) => {return step.id === 'crew-feedback';});

	/* If new card is selected, briefly show no card to reset flip component */
	useEffect(() => {
		let newSelectedCard = null;
		let newSelectedSlotId = null; 
		if (group.activeFeedbackCrewId) {
			if (crewData.availableCrew.some((person) => {return person.id === group.activeFeedbackCrewId;})
			) {
				newSelectedCard = crewData.availableCrew.find((person) => {
					return person.id === group.activeFeedbackCrewId;
				});
				newSelectedCard.effectApplied = group.selectedCrew.filter((crew) => {
					return crew.id === newSelectedCard.id;
				})[0].effectApplied;
			}
			if (group.selectedCrew.some((person) => {return person.id === group.activeFeedbackCrewId;})) {
				newSelectedSlotId = group.selectedCrew.find((person) => {
					return person.id === group.activeFeedbackCrewId;
				}).slotId;
			}
		}
		if (
			newSelectedCard !== null && selectedCard !== null && newSelectedCard !== selectedCard &&
			newSelectedSlotId !== null && selectedSlotId !== null && newSelectedSlotId !== selectedSlotId
		) {
			setSelectedCard(null);
			setSelectedSlotId(null);
		} else {
			setSelectedCard(newSelectedCard);
			setSelectedSlotId(newSelectedSlotId);
		}
	}, [selectedCard, selectedSlotId, crewData.availableCrew, group.activeFeedbackCrewId, group.selectedCrew]);

	/* Find first crewmember for which effects have not been applied */
	let nextCrewmember = group.selectedCrew.find((c) => {
		return (!c.hasOwnProperty('effectApplied') || c.effectApplied === false);
	});

	/* Confirmation button data */
	let allCardsFlipped = (group.selectedCrew.filter((crew) => {
		return (crew.effectApplied && crew.effectApplied === true);
	}).length === group.selectedCrew.length);
	let confirmBtnData = getConfirmButtonData(
		allCardsFlipped, 
		game, 
		'crew-feedback', 
		getText(generalUiTexts.next, game.languageId)
	);
	if (!confirmBtnData.isDisabled) confirmBtnData.classes.push('animate');
	
	return (
		<div className="CrewFeedbackHeli" onClick={() => {handleSelectSlotCRMH(null);}}>
			<Logo onClick={() => {handleGoToPage('welcome');}} />
			<ProgressBar 
				gameType={game.type}
				title={getText(gameStepData.title, game.languageId)} 
				subtitle={getText(gameStepData.subtitle, game.languageId)} 
			/>
			<Button 
				isDisabled={confirmBtnData.isDisabled}
				text={confirmBtnData.text}
				classes={confirmBtnData.classes}
				onClick={() => {confirmAndContinue('crew-feedback');}}
			/>
			<div className="CrewFeedback-helicopterBackground" />
			<div className="CrewFeedbackHeli-selectedWrapper">
				<div className="CrewFeedbackHeli-row">
					{crewData.crewSlots.filter((slot) => {return slot.type === 'pilot';}).map((slot) => {
						let selectedCrewMember = group.selectedCrew.find((crew) => {return crew.slotId === slot.id;});
						let crewId = selectedCrewMember.id;
						let cardData = [...crewData.availableCrew].find((person) => {return person.id === crewId;});
						cardData.slotExperienceId = slot.experienceId;
						return (
							<div 
								key={slot.id} 
								className={'CrewFeedbackHeli-slot' + (nextCrewmember && 
									nextCrewmember.id === crewId && slot.id !== selectedSlotId
									? ' shake' : '')}
							>
								<span className="CrewFeedbackHeli-slotTitle">
									{getText(slot.title, game.languageId)}
								</span>
								{slot.id !== selectedSlotId && 
									<CrewCardFlippable 
										canFlip={false}
										languageId={game.languageId}
										gameType={game.type}
										layout={(selectedCrewMember.effectApplied === true 
											? 'crewFeedbackWhite' : 'crewFeedback'
										)}
										cardData={cardData}
										cardTitle={getText(slot.title, game.languageId)}
										selectedCrew={group.selectedCrew}
										onClick={() => {handleSelectSlotCRMH(slot.id);}}
									/>}
							</div>
						);
					})}
				</div>
				<div className="CrewFeedbackHeli-row">
					{crewData.crewSlots.filter((slot) => {return slot.type !== 'pilot';}).map((slot) => {
						let selectedCrewMember = group.selectedCrew.find((crew) => {
							return crew.slotId === slot.id;
						});
						let crewId = selectedCrewMember.id;
						let cardData = [...crewData.availableCrew].find((person) => {return person.id === crewId;});
						cardData.slotExperienceId = slot.experienceId;
						return (
							<div 
								key={slot.id} 
								className={'CrewFeedbackHeli-slot' + (nextCrewmember && 
										nextCrewmember.id === crewId && slot.id !== selectedSlotId
									? ' shake' : '')}
							>
								<div className="CrewFeedbackHeli-slotTitle">
									<span>{getText(slot.title, game.languageId)}</span>
								</div>
								{slot.id !== selectedSlotId && 
										<CrewCardFlippable 
											canFlip={false}
											languageId={game.languageId}
											gameType={game.type}
											layout={(selectedCrewMember.effectApplied === true 
												? 'crewFeedbackWhite' : 'crewFeedback'
											)}
											cardData={cardData}
											cardTitle={getText(slot.title, game.languageId)}
											effectApplied={(selectedCrewMember.effectApplied === true)}
											selectedCrew={group.selectedCrew}
											onClick={() => {handleSelectSlotCRMH(slot.id);}}
										/>}
							</div>
						);
					})
					}
				</div>
			</div>

			<div className="CrewFeedbackHeli-selectedSlot">
				<div className={'CrewFeedbackHeli-instructions' + (selectedCard ? ' hide' : '')}>
					<div className="CrewFeedbackHeli-instructionsTitle">
						{getText(generalUiTexts.crewFeedbackInstructionsTitle, game.languageId)}
					</div>
					<div className="CrewFeedbackHeli-instructionsText">
						{renderMarkdown(getText(generalUiTexts.crewFeedbackInstructionsTextHeli, game.languageId))}
					</div>
				</div>
				{selectedCard && 
					<div className="CrewFeedbackHeli-selectedCrewContainer">
						<CrewCardFlippable 
							canFlip={true}
							languageId={game.languageId}
							gameType={game.type}
							layout="crewFeedbackSelected"
							cardData={selectedCard}
							selectedCrew={group.selectedCrew}
						/>
					</div>}
			</div>

			<div className="CrewFeedbackHeli-stats">
				<CrewExperience 
					languageId={game.languageId} 
					gameType={game.type} 
					type="feedback" 
					selectedCrew={group.selectedCrew} 
				/>
				<span>&nbsp;</span>
				<CrewIssues 
					languageId={game.languageId} 
					gameType={game.type} 
					type="feedback" 
					selectedCrew={group.selectedCrew} 
				/>
			</div>
		</div>
	);
};

CrewFeedbackHeli.propTypes = {
	game: PropTypes.object.isRequired,
	group: PropTypes.object.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
	handleSelectSlotCRMH: PropTypes.func.isRequired,
	confirmAndContinue: PropTypes.func.isRequired,
};

export default CrewFeedbackHeli;